export default [
  {
    path: '/exam-discuss/index',
    name: 'index',
    component: () => import('@/views/exam-discuss/index'),
    meta: {
      title: '2023年广东学考回忆录·高考直通车'
    }
  },
  {
    path: '/exam-discuss/circle',
    name: 'circle',
    component: () => import('@/views/exam-discuss/circle'),
    meta: {
      title: '2023年广东学考回忆录·高考直通车'
    }
  },
  {
    path: '/exam-discuss/myRecord',
    name: 'myRecord',
    component: () => import('@/views/exam-discuss/myRecord'),
    meta: {
      title: '2023年广东学考回忆录·高考直通车'
    }
  },
  {
    path: '/exam-discuss/detail',
    name: 'detail',
    component: () => import('@/views/exam-discuss/detail'),
    meta: {
      title: '2023年广东学考回忆录·高考直通车'
    }
  },
]